const headerTranslations = {
  mealsPdfButton: "Export Meals And Snacks",
  exercisesPdfButton: "Export exercises",
};

export default headerTranslations;
